import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { ASSET_LOG } = API_ROUTES;

class AssetLogService {
  getAssetLog = (id: string | undefined) => sendCall(`${ASSET_LOG.GET}/${id}`, { method: HTTP_METHODS.GET });

  getAssetLogs = (page: number, pagination: unknown) =>
    sendCall(`${ASSET_LOG.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  // Change to correct search
  getAssetLogsSearch = (params: unknown, page: number) =>
    sendCall(`${ASSET_LOG.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });
}

export default new AssetLogService();
